// Stub for server-only / Node-only modules accidentally pulled into the
// browser bundle. Two purposes:
//  1. Server-only npm packages (cld, deepl-node, @google-cloud/translate,
//     @techchange/request) imported by shared libs but never used in the
//     browser path.
//  2. Node builtins (tty, fs, net) referenced at module-load time by deps
//     like `debug` inside @techchange/components.
// The named exports cover the specific functions called at module-init time.

export const isatty = () => false;
export const readFileSync = () => '';
export const existsSync = () => false;
export const createConnection = () => null;

export default {
	isatty,
	readFileSync,
	existsSync,
	createConnection,
};
